import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import GroutHero from './components/GroutHero';
import GroutFeatures from './components/GroutFeatures';
import ContactCTA from '../components/ContactCTA';

export default function GroutPage() {
  return (
    <div className="min-h-screen bg-[#1A1A1A]">
      <Navbar />
      <GroutHero />
      <GroutFeatures />
      <ContactCTA />
      <Footer />
    </div>
  );
}
